module.exports = __webpack_public_path__ + "5438e9cce9b423910157609aeddc8495.png";